<template>
  <zm-tabs
    class="multi-tabs"
    v-model="tab"
    @tab-click="changeTab"
    type="card"
    id="multi-tab"
    v-if="current"
  >
    <zm-tab-pane
      v-for="(item,index) in list"
      :key="`${item.label}${index}`"
      :label="item.label"
      :name="item.uuid"
      @tab-click="changeTab(item)"
    >
      <span
        slot="label"
        :id="item.label"
        v-if="listLength > 1"
      > {{`${item.label}`}}
        <i
          class="zm-icon-close mgl-md"
          style="font-size: 12px;color: #737373;"
          @click.prevent.stop="closeTab(index)"
        ></i>
      </span>
    </zm-tab-pane>
  </zm-tabs>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'MultiTab',
  data () {
    return {
      tab: ''
    }
  },
  computed: {
    ...mapState('multiTabs', ['list', 'current']),
    listLength () {
      return this.list.length
    }
  },
  watch: {
    'current': {
      deep: true,
      immediate: true,
      handler (v) {
        if (v) {
          this.tab = v.uuid
        }
      }
    }
  },
  methods: {
    ...mapMutations('multiTabs', ['setCurrent']),
    changeTab () {
      this.setCurrent(this.list.find(m => m.uuid === this.tab))
      this.$router.push(this.current)
    },
    closeTab (index) {
      this.$MultiTabs.remove(index)
    }
  }
}
</script>

<style lang="scss">
.multi-tabs {
  width: calc(100% - 450px);
  &.zm-tabs--card {
    // box-sizing: border-box;
  }
  &.zm-tabs--top,
  .zm-tabs--bottom {
    border-bottom: 0;
    margin-bottom: 0;
  }
  .zm-tabs__header {
    margin-bottom: 0;
  }
  &.zm-tabs--card > .zm-tabs__header .zm-tabs__item {
    box-sizing: border-box;
    height: 29px;
    padding: 0 8px 0 24px;
    line-height: 27px;
    border-bottom: none;
    font-size: 14px;
  }
  &.zm-tabs--card > .zm-tabs__header .zm-tabs__item .zm-icon-close {
    width: 12px;
    right: 0;
    &:hover {
      background-color: #e0ddddbd;
    }
  }
  &.zm-tabs--card > .zm-tabs__header .zm-tabs__nav {
    border: 1px solid #d8dce5;
    border-bottom: none;
  }
  &.zm-tabs--card > .zm-tabs__header .zm-tabs__item.is-active {
    border-bottom: 1px solid #fff;
  }
  &.zm-tabs--card > .zm-tabs__header {
    border-bottom: 1px solid #d8dce5;
  }
}
</style>
